module.exports = __webpack_public_path__ + "assets/img/FAVORITOS_1.a0a34baa.svg";